import React from "react";
import LandingSection from "../components/LandingSection";
import "../styles/SiteMap.css"; // Make sure your hexagon CSS is here
import Header from "../components/Header";
import { useState } from "react";
import "../App.css";
import Footer from "../components/Footer";

const verticals = [
  {
    title: " ",
    text: " ",
    imagepath: " ",
    path: " ",
    logo: " ",
    bgColor: " ",
  },
  {
    title: "Real Estate and Rental and Leasing",
    path: "/wip",
    bgColor: "#C70039",
  },
  {
    title: "Manufacturing",
    path: "/verticals/manufacturing ",
    bgColor: "#1542c4",
  },
  {
    title: "Aerospace and Defense",
    path: "/verticals/aerospace-and-defense ",
    bgColor: "#C70039",
  },
  {
    title: "Food Industry",
    path: "/verticals/food-industry ",
    bgColor: "#1542c4",
  },
  {
    title: "Government (Public Administration)",
    path: "/wip",
    bgColor: "#1542c4",
  },
  {
    title: "Professional, Scientific, and Technical Services",
    path: "/verticals/professional-scientific-and-technical-services",
    bgColor: "#C70039",
  },
  {
    title: "Healthcare and Social Assistance",
    path: "/wip",
    bgColor: "#1542c4",
  },
  {
    title: "Finance and Insurance",
    path: "/wip",
    bgColor: "#C70039",
  },
  {
    title: "Retail Trade",
    path: "/wip",
    bgColor: "#1542c4",
  },
  {
    title: "Wholesale Trade",
    path: "/wip",
    bgColor: "#C70039",
  },
  {
    title: "Information",
    path: "/verticals/information",
    bgColor: "#1542c4",
  },
  {
    title: "Construction",
    path: "/verticals/construction",
    bgColor: "#C70039",
  },
  {
    title: "Transportation and Warehousing",
    path: "/verticals/transportation-and-warehousing",
    bgColor: "#1542c4",
  },
  {
    title: "Utilities",
    path: "/wip",
    bgColor: "#C70039",
  },
  {
    title: "Mining",
    path: "/verticals/mining",
    bgColor: "#1542c4",
  },
  {
    title: "Arts, Entertainment, and Recreation",
    path: "/wip",
    bgColor: "#1542c4",
  },
  {
    title: " ",
    text: " ",
    imagepath: " ",
    path: " ",
    logo: " ",
    bgColor: " ",
  },
];

const UtahAtAGlance = [
  {
    title: " ",
    text: " ",
    imagepath: " ",
    path: " ",
    logo: " ",
    bgColor: " ",
  },

  {
    title: "Governor’s Corner",
    text: "A direct look at the Governor’s initiatives, vision, and statewide priorities shaping Utah’s future.",
    imagepath: "/img/glance-webp/utah_governor_img.webp",
    path: "/utah-at-a-glance/utah-governor",
    logo: "/img/governor/gov_logo.png",
    bgColor: "#C70039",
  },
  {
    title: "Adventure Activities",
    text: "Utah offers thrilling adventure sports like rock climbing, mountain biking, rafting, and skiing, set against its stunning natural landscapes.",
    imagepath: "/img/glance-webp/portrait-couple-horses.webp",
    path: "/utah-at-a-glance/adventure-activities",
    bgColor: "#1542c4",
  },
  {
    title: "Air Quality Index",
    text: "Utah's air quality fluctuates seasonally, with inversions and wildfires impacting pollution levels. Alerts help residents take precautions when AQI is poor.",
    imagepath: "/img/glance-webp/traveller-with-beanie-relaxing-outdoors.webp",
    path: "/utah-at-a-glance/air-quality-index",
    bgColor: "#1542c4",
  },
  {
    title: "Airports",
    text: "Utah's airports, led by Salt Lake City International, provide vital air connectivity across the state and beyond.",
    imagepath: "/img/glance-webp/airport.webp",
    path: "/utah-at-a-glance/utah-airports ",
    bgColor: "#1542c4",
  },
  {
    title: "Charging Stations",
    text: "Utah is building a strong EV charging network, with fast chargers and public stations expanding across cities and highways.",
    imagepath: "/img/glance-webp/charging-station.webp",
    path: "/utah-at-a-glance/charging-stations",
    bgColor: "#C70039",
  },
  {
    title: "Cities",
    text: "Discover vibrant opportunities and connections across all major Utah cities",
    imagepath: "/img/glance-webp/cities.webp",
    path: "/utah-at-a-glance/utah-cities",
    bgColor: "#C70039",
  },
  {
    title: "Counties",
    text: "Utah has 29 diverse counties ranging from urban Salt Lake County to rural San Juan County, each offering unique landscapes from mountain ranges to desert red rocks.",
    imagepath: "/img/glance-webp/geoandinsights.webp",
    path: "/utah-at-a-glance/utah-counties",
    bgColor: "#C70039",
  },
  {
    title: " ",
    text: " ",
    imagepath: " ",
    path: " ",
    logo: " ",
    bgColor: " ",
  },
  {
    title: " ",
    text: " ",
    imagepath: " ",
    path: " ",
    logo: " ",
    bgColor: " ",
  },
  // {
  //   title: "Culture",
  //   text: "Explore local arts, history, values, and traditions that shape Utah's cultural identity.",
  //   imagepath: "/img/glance-webp/utahculture.webp",
  //   path: "/utah-at-a-glance/culture ",
  //   bgColor: "#1542c4",
  // },

  {
    title: "Demographics",
    text: "Understand who lives in Utah—age groups, ethnicity, education, income, and population trends.",
    imagepath: "/img/glance-webp/demographics.webp",
    path: "/utah-at-a-glance/demographics ",
    bgColor: "#1542c4",
  },
  {
    title: "Education and Intellectual Resources",
    text: "Discover vibrant opportunities and connections across all major Utah cities",
    imagepath: "/img/glance-webp/eduandresource.webp",
    path: "/utah-at-a-glance/universities-and-schools",
    bgColor: "#1542c4",
  },
  {
    title: "Utah Nonprofits",
    text: "Discover Utah's nonprofit organizations and their impact on the state.",
    imagepath: "/img/glance-webp/nonprofits.webp",
    path: "/utah-at-a-glance/utah-nonprofits",
    bgColor: "#C70039",
  },
  {
    title: "Employment",
    text: "Track Utah's job sectors, workforce trends, income levels, and economic output.",
    imagepath: "/img/glance-webp/jobs.webp",
    path: "/utah-at-a-glance/utah-employment ",
    bgColor: "#C70039",
  },
  {
    title: "Federal Agencies",
    text: "Utah is home to various federal departments and agencies that support public services, defense, land management, and community development across the state.",
    imagepath: "/img/glance-webp/new-york-city-ellis-island-great-hall.webp",
    path: "/utah-at-a-glance/federal-agencies",
    bgColor: "#1542c4",
  },
  {
    title: "Financial Institutions",
    text: "Review personal finance trends, average incomes, economic stability, and financial health.",
    imagepath: "/img/glance-webp/finance3.webp",
    path: "/utah-at-a-glance/financial-institutions",
    bgColor: "#1542c4",
  },
  //  /utah-at-a-glance/utah-funfacts
  // {
  //   title: "Fun Facts",
  //   text: "Utah Fun Facts: The Beehive State’s Hidden Wonders",
  //   imagepath: "/img/glance-webp/fun.webp",
  //   path: "/utah-at-a-glance/utah-funfacts",
  //   bgColor: "#C70039",
  // },
  {
    title: "Geothermal Hotspots",
    text: "Utah is rich in geothermal hotspots—particularly along the I‑15 corridor and in southwestern counties like Beaver—where underground heat fuels natural springs and geothermal power facilities.",
    imagepath: "/img/glance-webp/geo.webp",
    path: "/utah-at-a-glance/utah-geothermal-hotspots",
    bgColor: "#1542c4",
  },
  {
    title: "Hill Airforce Base",
    text: "Hill Air Force Base in Utah is a major U.S. Air Force installation known for its critical role in aircraft maintenance, logistics, and national defense operations.",
    imagepath: "/img/glance-webp/f-16.avif",
    path: "/utah-at-a-glance/hill-airforce-base",
    bgColor: "#C70039",
  },
  {
    title: "Hospitals",
    text: "Utah hospitals provide high-quality medical care across the state, serving both urban and rural communities with advanced healthcare services.",
    imagepath: "/img/glance-webp/hospital1.webp",
    path: "/utah-at-a-glance/hospitals",
    bgColor: "#1542c4",
  },
  {
    title: "Housing",
    text: "Utah's housing market reflects rapid growth and high demand, driven by population increases, economic expansion, and a strong influx of new residents seeking vibrant communities and quality of life.",
    imagepath: "/img/glance-webp/housing.webp",
    path: "/utah-at-a-glance/utah-housing",
    bgColor: "#1542c4",
  },
  {
    title: "Libraries",
    text: "Utah boasts a robust network of libraries",
    imagepath: "/img/glance-webp/interior.webp",
    path: "/utah-at-a-glance/utah-libraries",
    bgColor: "#C70039",
  },
  {
    title: "MLM",
    text: "Utah is a major hub for multi-level marketing (MLM), home to several prominent MLM companies and a strong direct sales culture.",
    imagepath: "/img/glance-webp/mlm.webp",
    path: "/utah-at-a-glance/mlm",
    bgColor: "#C70039",
  },
  {
    title: "Mines",
    text: "Uncover the industrial heart of Utah with a detailed look at its major mines",
    imagepath: "/img/glance-webp/mines.webp",
    path: "/utah-at-a-glance/utah-mines",
    bgColor: "#C70039",
  },
  {
    title: "Places to Visit",
    text: "Utah's air quality fluctuates seasonally, with inversions and wildfires impacting pollution levels. Alerts help residents take precautions when AQI is poor.",
    imagepath: "/img/glance-webp/stone-gate-bryce-canyon-national-park.webp",
    path: "/utah-at-a-glance/utah-places-to-visit",
    bgColor: "#C70039",
  },
  {
    title: "Research Centers and Institutes",
    text: "Research Centers and Institutes: Advancing Innovation Across Utah",
    imagepath: "/img/glance-webp/research.webp",
    path: "/utah-at-a-glance/research-centers-and-institutes",
    bgColor: "#1542c4",
  },
  {
    title: "Sports Club",
    text: "Highlighting major and minor league teams, college athletics, and community sports programs.",
    imagepath: "/img/glance-webp/sports.webp",
    path: "/utah-at-a-glance/sports-club",
    bgColor: "#C70039",
  },
  {
    title: "Taxes",
    text: "Understand how Utah ranks in taxation, incentives, and economic competitiveness.",
    imagepath: "/img/glance-webp/taxes.webp",
    path: "/utah-at-a-glance/taxes ",
    bgColor: "#C70039",
  },
  //  {
  //   title: " ",
  //   text: " ",
  //   imagepath: " ",
  //   path: " ",
  //   logo: " ",
  //   bgColor:" "
  // },
  //  {
  //   title: " ",
  //   text: " ",
  //   imagepath: " ",
  //   path: " ",
  //   logo: " ",
  //   bgColor:" "
  // },
  //  {
  //   title: " ",
  //   text: " ",
  //   imagepath: " ",
  //   path: " ",
  //   logo: " ",
  //   bgColor:" "
  // },

  {
    title: "Unemployment Rate",
    text: "Utah maintains one of the lowest unemployment rates in the nation, reflecting a resilient and stable economy.",
    imagepath: "/img/glance-webp/unemployment1.webp",
    path: "/utah-at-a-glance/unemployment-rate",
    bgColor: "#C70039",
  },
  {
    title: "Autism and DD",
    text: "Welcome to Utah’s Autism and Developmental Disabilities Data Hub, powered by URADD",
    imagepath: "/img/glance-webp/uradd.webp",
    path: "/utah-at-a-glance/autism-dd",
    bgColor: "  #1542c4",
  },
  {
    title: "Voters Count",
    text: "Engage with statistics on voting participation, registration, and electoral history.",
    imagepath: "/img/glance-webp/voterscount.webp",
    path: "/utah-at-a-glance/utah-voters-count",
    bgColor: "#C70039",
  },
  {
    title: "Zip Codes",
    text: " Utah ZIP codes organize the state's regions for efficient mail delivery and reflect geographic and population distribution across counties and cities.",
    imagepath: "/img/glance-webp/close-up-magnifying-glass-map.webp",
    path: "/utah-at-a-glance/zipcodes",
    bgColor: "#1542c4",
  },

 
  {
    title: " ",
    text: " ",
    imagepath: " ",
    path: " ",
    logo: " ",
    bgColor: " ",
  },
  // {
  //   title: " ",
  //   text: " ",
  //   imagepath: " ",
  //   path: " ",
  //   logo: " ",
  //   bgColor: " "
  // }

  // {
  //   title: " ",
  //   text: " ",
  //   imagepath: " ",
  //   path: " ",
  //   logo: " ",
  //   bgColor:" "
  // },
];

// const generateHexRows = () => {
//   const width = window.innerWidth;
//   const rows = [];

//   if (width <= 600) {
//     // 🔹 Mobile: alternate 3 and 2 items per row
//     for (let i = 0, toggle = true; i < UtahAtAGlance.length;) {
//       const count = toggle ? 3 : 2;
//       rows.push(UtahAtAGlance.slice(i, i + count));
//       i += count;
//       toggle = !toggle;
//     }
//   } else if (width > 600 && width < 1030) {
//     // 🔹 Tablet: 5 items per row
//     for (let i = 0; i < UtahAtAGlance.length; i += 5) {
//       rows.push(UtahAtAGlance.slice(i, i + 5));
//     }
//   } else {
//     // 🔹 Desktop: 7 items per row
//     for (let i = 0; i < UtahAtAGlance.length; i += 9) {
//       rows.push(UtahAtAGlance.slice(i, i + 9));
//     }
//   }

//   return rows;
// };

// const hexRows = generateHexRows();

const otherPages = [
  { title: " ", path: " ", bgColor: " " },

  { title: " ", path: " ", bgColor: " " },
  { title: "Login", path: "/login", bgColor: "#C70039" },
  { title: "About Us", path: "/about-us", bgColor: "#1542c4" },
  { title: "Privacy Policy", path: "/privacy-policy", bgColor: "#C70039" },
  { title: "Contact Us", path: "/contact-us", bgColor: "#1542c4" },

  { title: "Gallery", path: "/gallery", bgColor: "#C70039" },
  { title: "KCG", path: "/kcg", bgColor: "#1542c4" },
  { title: "Ask Betsy AI", path: "/betsy", bgColor: "#C70039" },
  { title: "NAICS", path: "/get-naics", bgColor: "#1542c4" },

  { title: "Copyright", path: "/copyright", bgColor: "#C70039" },
  { title: "FAQs", path: "/faq", bgColor: "#1542c4 " },
  { title: "Founder's Note", path: "/founders-note", bgColor: "#C70039 " },
  {
    title: "Support Sponsor Request",
    path: "/support-sponsor-request",
    bgColor: "#1542c4",
  },
  {
    title: "Supporters And Sponsors",
    path: "/supporters-and-sponsors",
    bgColor: "#C70039 ",
  },
  { title: "WIP", path: "/wip", bgColor: "#1542c4" },
  { title: " ", path: " ", bgColor: " " },
  { title: " ", path: " ", bgColor: " " },
];

const HexGridSection = ({
  title,
  data,
  activeTab,
  setActiveTab,
  setSelectedTitle,
  url,
}) => {
  const generateHexRows = () => {
    const width = window.innerWidth;
    const rows = [];

    if (width <= 600) {
      for (let i = 0, toggle = true; i < data.length; ) {
        const count = toggle ? 3 : 2;
        rows.push(data.slice(i, i + count));
        i += count;
        toggle = !toggle;
      }
    } else if (width > 600 && width < 1030) {
      for (let i = 0; i < data.length; i += 5) {
        rows.push(data.slice(i, i + 5));
      }
    } else {
      for (let i = 0; i < data.length; i += 9) {
        rows.push(data.slice(i, i + 9));
      }
    }

    return rows;
  };

  const hexRows = generateHexRows();

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <h1 className="text-3xl font-bold mb-6 text-center">
        <a href={url} className="no-underline">
          {" "}
          {title}
        </a>
      </h1>
      <div className="hex-grid">
        {hexRows.map((row, index) => (
          <div
            key={index}
            className={`hex-row ${index % 2 !== 0 ? "offset" : ""}`}
          >
            {row.map(({ title, path, bgColor }, i) => (
              <div key={i} className="hex-border">
                <div className="hex-wrapper">
                  {title && title.trim() !== "" ? (
                    <a
                      href={path || "#"}
                      className="hex-inner no-underline"
                      style={{ backgroundColor: bgColor || "#3a3aab" }}
                    >
                      <div className="upperHexa">
                        <div
                          className={`hexagon ${activeTab === title ? "active" : ""}`}
                          onClick={() => {
                            setActiveTab(title);
                            setSelectedTitle(title);
                          }}
                          style={{ color: bgColor }}
                        >
                          <span className="hex-title">{title}</span>
                        </div>
                      </div>
                    </a>
                  ) : null}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

function SiteMap2() {
  const [selectedTitle, setSelectedTitle] = useState(null);
  // const filteredCards = selectedTitle ? leftPanel.filter((item) =>(item.title===selectedTitle)):leftPanel
  const [activeTab, setActiveTab] = useState("");
  return (
    <div>
      {/* <LandingSection data={{ imageName: 'recreation.webp', title: 'Utah Site Map' }} /> */}

      <Header />
      <div className="mt-[8rem]">
        <h1 className="flex justify-center">UTahData.org Visual Site Map</h1>
        {/* <HexGridSection title="Utah Verticals" data={verticals} />
      <HexGridSection title="Utah At a Glance" data={UtahAtAGlance} />
      <HexGridSection title="Other Pages" data={otherPages} /> */}
        <HexGridSection
          title="Utah Verticals"
          data={verticals}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          setSelectedTitle={setSelectedTitle}
          url="/verticals"
        />
        <HexGridSection
          title="Utah At a Glance"
          data={UtahAtAGlance}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          setSelectedTitle={setSelectedTitle}
          url="/utah-at-a-glance"
        />
        <HexGridSection
          title="Other Pages"
          data={otherPages}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          setSelectedTitle={setSelectedTitle}
          url=""
        />
      </div>
      <Footer />
    </div>
  );
}

export default SiteMap2;

